<template>
  <div>
    <h1 class="text-center mt-3">Shiseido Product category</h1>
    <v-progress-circular
      v-if="isLoading"
      :size="70"
      :width="7"
      color="primary"
      indeterminate
      class="centered"
    ></v-progress-circular>
    <div v-else>
      <div class="form shadow p-5 mb-5 bg-white rounded">
        <div class="row">
          <div class="col-6">
            <label for="futureSolution">Future Solution</label>
            <input
              id="futureSolution"
              type="text"
              v-model="form.futureSolution"
              class="form-control"
              :class="{
                'input--error': isSubmit && error.errorFutureSolution,
              }"
              @focus="showFutureSolutionInstruction = true"
              @blur="showFutureSolutionInstruction = false"
            />
            <p
              class="futureSolutionInstruction"
              v-if="showFutureSolutionInstruction"
            >
              <small
                >Use comma as a separator of each product category name</small
              >
            </p>
            <div
              v-if="isSubmit && error.errorFutureSolution"
              class="text-error"
            >
              {{ error.errorFutureSolution.message }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <label for="ultimune">Ultimune</label>
            <input
              id="ultimune"
              type="text"
              v-model="form.ultimune"
              class="form-control"
              :class="{
                'input--error': isSubmit && error.errorUltimune,
              }"
            />
            <div v-if="isSubmit && error.errorUltimune" class="text-error">
              {{ error.errorUltimune.message }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <label for="vitalPerfection">Vital Perfection</label>
            <input
              id="vitalPerfection"
              type="text"
              v-model="form.vitalPerfection"
              class="form-control"
              :class="{
                'input--error': isSubmit && error.errorVitalPerfection,
              }"
            />
            <div
              v-if="isSubmit && error.errorVitalPerfection"
              class="text-error"
            >
              {{ error.errorVitalPerfection.message }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <label for="globalSunscreen">Global Sunscreen</label>
            <input
              id="globalSunscreen"
              type="text"
              v-model="form.globalSunscreen"
              class="form-control"
              :class="{
                'input--error': isSubmit && error.errorGlobalSunscreen,
              }"
            />
            <div
              v-if="isSubmit && error.errorGlobalSunscreen"
              class="text-error"
            >
              {{ error.errorGlobalSunscreen.message }}
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-5">
          <button
            class="btn btn-outline-danger ml-10"
            @click="() => $router.go()"
          >
            Cancel
          </button>
          <button class="btn btn-outline-success ml-10" @click="onSubmit">
            Save
          </button>
        </div>
      </div>

      <v-dialog v-model="showDialog" width="500" persistent>
        <div class="content-dialog">
          <h3 class="p-5">{{ message }}</h3>
          <div class="text-center">
            <button class="btn-back" @click="showDialog = false">ปิด</button>
          </div>
        </div>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import ShiseidoProductCategoryService from "services/api/shiseidoProductCategory.service";

export default {
  data() {
    return {
      message: "",
      showDialog: false,
      isLoading: true,
      isSubmit: false,
      showFutureSolutionInstruction: false,
      form: {
        futureSolution: null,
        ultimune: null,
        vitalPerfection: null,
        globalSunscreen: null,
      },
      error: {
        errorFutureSolution: null,
        errorUltimune: null,
        errorVitalPerfection: null,
        errorGlobalSunscreen: null,
      },
    };
  },
  mounted() {
    this.getShiseidoProductCategoryList();
  },
  methods: {
    onSubmit() {
      this.isSubmit = true;
      this.isLoading = true;
      this.resetErrorText();
      const form = this.form;
      const body = {
        futureSolution: form.futureSolution,
        ultimune: form.ultimune,
        vitalPerfection: form.vitalPerfection,
        globalSunscreen: form.globalSunscreen,
      };

      this.updateShiseidoProductCategory(body);
    },
    async updateShiseidoProductCategory(body) {
      await ShiseidoProductCategoryService.setShiseidoProductCategory(body)
        .then(async (res) => {
          const data = res.data;
          await this.getShiseidoProductCategoryList();
          this.isLoading = false;
          this.showDialog = true;
          this.message = data.message
            ? data.message
            : "Save Shiseido Product Category success";
        })
        .catch((err) => {
          this.isLoading = false;
          const errorData = err.response?.data;
          if (errorData.errors?.length > 0) {
            this.setErrorText(errorData.errors);
            return;
          }
          if (errorData?.message) {
            this.showDialog = true;
            this.message = errorData.message;
          }
        });
    },
    async getShiseidoProductCategoryList() {
      await ShiseidoProductCategoryService.getShiseidoProductCategory()
        .then((res) => {
          const data = res.data;
          this.isLoading = false;
          const form = this.form;
          form.futureSolution = data.futureSolution;
          form.ultimune = data.ultimune;
          form.vitalPerfection = data.vitalPerfection;
          form.globalSunscreen = data.globalSunscreen;
        })
        .catch((err) => {
          this.isLoading = false;
          const errorData = err.response?.data;
          if (errorData?.message) {
            this.showDialog = true;
            this.message = errorData.message;
          }
        });
    },
    setErrorText(errors) {
      this.error.errorFutureSolution = errors.find(
        (e) => e.fieldName === "futureSolution"
      );
      this.error.errorUltimune = errors.find((e) => e.fieldName === "ultimune");
      this.error.errorVitalPerfection = errors.find(
        (e) => e.fieldName === "vitalPerfection"
      );
      this.error.errorGlobalSunscreen = errors.find(
        (e) => e.fieldName === "globalSunscreen"
      );
    },
    resetErrorText() {
      this.error.errorFutureSolution = null;
      this.error.errorUltimune = null;
      this.error.errorVitalPerfection = null;
      this.error.errorGlobalSunscreen = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.text-error {
  color: red;
  font-size: 12px;
}

.futureSolutionInstruction {
  color: red;
  text-align: right;
  margin-bottom: 0;
}

.content-dialog {
  height: 300px;
  background: #fff;
  overflow-x: hidden;

  h3 {
    text-align: center;
    padding: 5rem 0 2rem;
  }

  .btn-back {
    border: 1px solid #1976d2;
    width: 28%;
    height: 39px;
    border-radius: 25px;
    color: #1976d2;
  }

  .btn-back:hover {
    text-decoration: underline;
  }
}
</style>
